import roomService from '../../services/roomService';

const state = {
  rooms: [],
  loading: false,
  error: null
};

const getters = {
  allRooms: state => state.rooms
};

const actions = {
  async fetchRooms({ commit }) {
    commit('SET_LOADING', true);
    try {
      const response = await roomService.getRooms();
      console.log('Room API response:', response);
      if (response.success) {
        commit('SET_ROOMS', response.data);
      }
      commit('SET_LOADING', false);
      return response;
    } catch (error) {
      console.error('Error fetching rooms:', error);
      commit('SET_ERROR', error);
      commit('SET_LOADING', false);
      throw error;
    }
  },

  async addRoom({ commit }, roomData) {
    const response = await roomService.addRoom(roomData);
    commit('newRoom', response.data);
  },

  async updateRoom({ commit }, roomData) {
    const response = await roomService.updateRoom(roomData.id, roomData);
    commit('updateRoom', response.data);
  },

  async deleteRoom({ commit }, roomId) {
    await roomService.deleteRoom(roomId);
    commit('removeRoom', roomId);
  },

  async fetchDisabledDates({ commit }, { roomId, bookingType }) {
    try {
      commit('SET_LOADING', true);
      const response = await roomService.getAvailableDates(roomId, bookingType);
      console.log('Raw API response in store:', response);
      
      if (response.success) {
        console.log('Returning disabled dates from store:', response.data);
        return response;
      }
      commit('SET_LOADING', false);
    } catch (error) {
      console.error('Error fetching disabled dates:', error);
      commit('SET_LOADING', false);
      commit('SET_ERROR', error);
      throw error;
    }
  }
};

const mutations = {
  SET_ROOMS(state, rooms) {
    state.rooms = Array.isArray(rooms) ? rooms : [];
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  newRoom: (state, roomData) => state.rooms.push(roomData),
  updateRoom: (state, updatedRoom) => {
    const index = state.rooms.findIndex(room => room.id === updatedRoom.id);
    if (index !== -1) {
      state.rooms.splice(index, 1, updatedRoom);
    }
  },
  removeRoom: (state, roomId) => {
    state.rooms = state.rooms.filter(room => room.id !== roomId);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 